<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/bulk-order/shared/bulk-order/bulk-order.component.ts
-->
<ng-template #anchor></ng-template>
